import React from 'react'
import style from './styles.module.css'
import Topheader from '../../components/Topheader'
export default function NewFaq() {
  const data=[
    {
      id:"q1",
      ques:"1. What are Chips?",
      ans:"Chips are your in-game currency used to play poker games and tournaments. You can claim daily and hourly (every 60 minutes) and can also be earned by watching ads or completing tasks."
    },
    {
      id:"q2",
      ques:"2. I’ve run out of Chips. What should I do?",
      ans:"You can claim daily and hourly (every 60 minutes). You can also earn more by watching ads or completing task rewards."
    },
    {
      id:"q3",
      ques:"3. What are Reward Points?",
      ans:"Reward Points are earned through gameplay — by ranking on leaderboards, finishing in paid tournament positions, or completing tasks. They can be redeemed in the Baazi Store for offers and gift cards from top brands."
    },
    {
      id:"q4",
      ques:"4. How do I earn Reward Points?",
      ans:"Play games, climb leaderboards, complete daily tasks, or finish in tournament payout positions to earn Reward Points."
    },
    {
      id:"q5",
      ques:"5. How can I use Reward Points?",
      ans:"Open the Baazi Store in the app, choose your desired offer or voucher, and redeem using your available Reward Points."
    },
    {
      id:"q6",
      ques:"6. Can Reward Points be redeemed for cash?",
      ans:"No. Reward Points can only be used to redeem offers or vouchers in the Baazi Store."
    },
    {
      id:"q7",
      ques:"7. I redeemed my Reward Points but didn’t receive the item.",
      ans:"Please allow up to 48 hours for processing. If not received, contact Support with your reward name and redemption date for assistance."
    },
    {
      id:"q8",
      ques:"8. Can I transfer Chips or Reward Points to another player?",
      ans:"No. Both Chips and Reward Points are non-transferable and linked only to your account."
    },
    {
      id:"q9",
      ques:"9. Where can I check my balances?",
      ans:"You can view your Chips and Reward Points in the Wallet section of the app at any time."
    },
    {
      id:"q10",
      ques:"10. My balance hasn’t updated. What should I do?",
      ans:"Refresh the app or log out and back in. If the issue persists, reach out to Support with your username and gameplay details."
    },
    
  ]
  return (
    <div>
      <Topheader colorbox="newfaq_header_color" title="FAQs" />
      <div className="main-container mb-5 mt-4 ">
        
        <div className={style.btm_safe}>
          <div id="accordion">
            {data.map((item,index)=>{
          return(
            <div key={index} className={`${style.box}`}>
            <div className={`${style.accordionHeader} collapsed`} data-bs-toggle="collapse" href={`#${item.id}`}>
              <div className={style.title_box}>
                <span className={style.title}>{item.ques}</span>
                <svg className={style.arrowIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12.0002 7L8.00051 11L4.00025 7" stroke="#041B67" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>


            <div id={item.id} className='collapse mt-2' data-bs-parent="#accordion">
              <div className={style.desc}>
                {item.ans}
              </div>
            </div>
            </div>
             )
        })}
          </div>
        </div>
         

        
      </div>

      <div className={style.btm_fixed_area}>
        <div className={style.btn}>
         <a href='mailto:playerrelations@pokerbaazi.com' target='_blank' rel="noreferrer" style={{color:'white'}}>Write To Us</a>

        </div>

      </div>
    </div>
  )
}
